import React, { memo } from 'react';

import ReactTooltip, {
  tooltipClasses,
  TooltipProps,
} from '@mui/material/Tooltip';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const useRegularStyles = makeStyles((theme: Theme) => ({
  popper: {
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      ...theme.typography.body2,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.common.black,
      padding: theme.spacing(1, 3),
      whiteSpace: 'pre-wrap',
    },
  },
}));

const useSmallStyles = makeStyles((theme: Theme) => ({
  popper: {
    [`& .${tooltipClasses.tooltip}`]: {
      ...theme.typography.body2,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.common.black,
      padding: theme.spacing(0.5, 1),
      margin: theme.spacing(0.5, 0),
    },
    [`&[data-popper-placement*="top"] .${tooltipClasses.tooltip}.${tooltipClasses.tooltipPlacementTop}`]:
      {
        marginBottom: 8,
      },
  },
}));

interface VariationProps extends TooltipProps {
  small?: boolean;
  requireDiv?: boolean;
}

export interface TooltipTextProps extends Partial<TooltipProps> {
  title?: string;
  children: React.ReactElement;
  requireDiv?: boolean;
}

export const Tooltip = ({
  title,
  arrow,
  small,
  requireDiv,
  ...props
}: VariationProps) => {
  const regularClasses: any = useRegularStyles();
  const smallClasses: any = useSmallStyles();
  if (!title) {
    return props.children;
  }

  if (requireDiv) {
    const { children, ...rest } = props;
    return (
      <ReactTooltip
        arrow={arrow}
        classes={small ? smallClasses : regularClasses}
        title={title}
        {...rest}
      >
        <div>{children}</div>
      </ReactTooltip>
    );
  }

  return (
    <ReactTooltip
      arrow={arrow}
      classes={small ? smallClasses : regularClasses}
      title={title}
      {...props}
    />
  );
};

export const TooltipText = memo(function TooltipTextComp({
  title,
  ...rest
}: TooltipTextProps) {
  return <Tooltip title={title} arrow {...rest} />;
});
